<script setup lang="ts"></script>

<template>
    <div class="mt-9 flex flex-col gap-12">
        <CommFeatureSection
            headline="Übersicht"
            :images="[
                {
                    url: '/images/job-ads/features/business-portal/dashboard.webp',
                    alt:
                        'Das Dashboard im Business Portal. Eingeloggt befindet sich links die Navigation mit den Punkten Übersicht, Profil, Inserate, Guthaben, Talentdatenbank, Employer Branding und Recruiting Services.\n' +
                        'Rechts sind die drei aktuellsten Inserate inklusive restlicher Laufzeit aufgelistet. Man sieht auch das aktuelle Guthaben und aktuelle Kontingente. Am Seitenende können Online-Shop-Rechnungen eingesehen werden und es gibt eine Kontaktmöglichkeit.',
                },
            ]"
        >
            <template #text>
                <BaseText as="span">
                    <BaseText as="span" variant="base-500">
                        Alles auf einem Blick:
                    </BaseText>
                    Übersicht über alle Ihre Produkte und Services.
                </BaseText>
                <BaseText>
                    <BaseText as="span" variant="base-500">
                        Einfache Produkt-Verwaltung:
                    </BaseText>
                    Direkte Erstellung und Aktivierung Ihrer Produkte und
                    Services sowie einfaches Hinzubuchen weiterer Produkte.
                </BaseText>
                <BaseText>
                    <BaseText as="span" variant="base-500">
                        Effizientes Bewerbungsmanagement:
                    </BaseText>
                    Direkt im Business Portal und datenschutzkonform mit dem
                    karriere.at bewerber.manager oder über die Anbindung an Ihr
                    eigenes ATS-System.
                </BaseText>
                <BaseText>
                    <BaseText as="span" variant="base-500">
                        Verwaltung von Firmendaten und Rechnungen:
                    </BaseText>
                    Bearbeiten Sie Ihre Firmendaten und sehen Sie Online Shop
                    Rechnungen ein.
                </BaseText>
            </template>
        </CommFeatureSection>
        <CommFeatureSection
            class="lg:!flex-row-reverse"
            headline="Inseraterstellprozess"
            :images="[
                {
                    url: '/images/job-ads/features/business-portal/job-ad-creation/step-1-data.webp',
                    alt: '1. Schritt des Inseraterstellprozess: Eingabe der Basisdaten (Titel, Sprache, Anrede, Berufsfelder, Arbeitsmodell etc.)',
                },
                {
                    url: '/images/job-ads/features/business-portal/job-ad-creation/step-2-content.webp',
                    alt: '2. Schritt des Inseraterstellprozess: Eingabe des Inhaltes (Überschrift, Aufgaben, Anforgerungen, Angebot, etc.)',
                },
                {
                    url: '/images/job-ads/features/business-portal/job-ad-creation/step-3-application.webp',
                    alt: '3. Schritt des Inseraterstellprozess: Einstellungen zur Zustellung der Bewerbung (E-Mail, Ansprechpartner, Dokumente, Bewerbungsschritte)',
                },
                {
                    url: '/images/job-ads/features/business-portal/job-ad-creation/step-4-design.webp',
                    alt: '4. Schritt des Inseraterstellprozess: Gestalten des Designs (Möglichkeiten je nach Produkt unterschiedlich (z.B. Titelbild, Farben, Video, Bildergalerie)',
                },
                {
                    url: '/images/job-ads/features/business-portal/job-ad-creation/step-5-summary.webp',
                    alt: '5. Schritt des Inseraterstellprozess: Zusammenfassung aller eingegebenen Daten',
                },

                {
                    url: '/images/job-ads/features/business-portal/job-ad-creation/step-6-publish.webp',
                    alt: '6. Schritt des Inseraterstellprozess: Finale Veröffentlichung (Auswahl des Guthabens)',
                },
            ]"
        >
            <template #text>
                <BaseText>
                    <BaseText as="span" variant="base-500">
                        Einfache Erstellung und Bearbeitung:
                    </BaseText>
                    Mit unserem intuitiven Erstellungsprozess können Sie Ihr
                    Stelleninserat schnell und mühelos erstellen, sofort online
                    veröffentlichen, nachträglich bearbeiten und das jederzeit
                    und überall - sogar mobil.
                </BaseText>
                <BaseText>
                    <BaseText as="span" variant="base-500"
                        >Intelligente Unterstützung:</BaseText
                    >
                    ChatGPT unterstützt Sie dabei, effektiv Inhaltstexte zu
                    formulieren.
                </BaseText>
                <BaseText>
                    <BaseText as="span" variant="base-500">
                        Maximale Individualität:
                    </BaseText>
                    Passen Sie Ihr Inserat entsprechend Ihrer
                    Unternehmensidentität mit Logo, Farben und Titelbild an (nur
                    Stelleninserat Plus & Premium).
                </BaseText>
            </template>
        </CommFeatureSection>
        <CommFeatureSection
            headline="Inserateübersicht – Verwaltung Ihrer Inserate"
            :images="[
                {
                    url: '/images/job-ads/features/business-portal/Inserateuebersicht.webp',
                    alt: 'Eine Inserat-Übersicht mit diversen Jobs. Es gibt eine Suchleiste und Filtermöglichkeiten. Für alle Jobs sind Status, Referenznummer, Titel, Ort, Produkt und die wichtigsten Kennzahlen und Bearbeitungsmöglichkeiten hinterlegt.',
                },
            ]"
        >
            <template #text>
                <BaseText>
                    <BaseText as="span" variant="base-500">
                        Transparenz:
                    </BaseText>
                    Verfolgen Sie den Status und die Laufzeit Ihrer
                    Stelleninserate. Dank klarer Kennzeichnungen sehen Sie
                    sofort, wann diese ablaufen.
                </BaseText>
                <BaseText>
                    <BaseText as="span" variant="base-500">
                        Flexible Verwaltung:
                    </BaseText>
                    Verwalten Sie Ihre Stelleninserate flexibel, indem Sie diese
                    bearbeiten, duplizieren oder deaktivieren.
                </BaseText>
                <BaseText>
                    <BaseText as="span" variant="base-500">
                        Kostenpflichtige Zusatzprodukte:
                    </BaseText>
                    Verlängern Sie die Laufzeit Ihrer Stelleninserate einmalig
                    oder fügen Sie einen Job-Push hinzu – jederzeit direkt im
                    Business Portal.
                </BaseText>
            </template>
        </CommFeatureSection>
    </div>
</template>
